var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54213 8.39897C1.74705 7.33504 1.3844 6.00932 1.52717 4.68868C1.66994 3.36803 2.30752 2.15051 3.31159 1.2812C4.31565 0.411897 5.61164 -0.0446558 6.93867 0.00344911C8.26571 0.051554 9.52526 0.600745 10.4638 1.54047C11.4023 2.4802 11.9501 3.74069 11.997 5.06821C12.0438 6.39573 11.5862 7.69171 10.7162 8.69529C9.84625 9.69886 8.62853 10.3355 7.30819 10.4771C5.98784 10.6186 4.6629 10.2546 3.60008 9.45828L1.05819 12L0.000244141 10.9437L2.54213 8.39897ZM6.72793 9.00915C7.4672 9.00915 8.18987 8.78986 8.80456 8.379C9.41924 7.96815 9.89832 7.38419 10.1812 6.70096C10.4641 6.01774 10.5382 5.26594 10.3939 4.54063C10.2497 3.81532 9.89372 3.14908 9.37097 2.62617C8.84823 2.10325 8.18221 1.74714 7.45715 1.60287C6.73208 1.45859 5.98053 1.53264 5.29753 1.81564C4.61453 2.09864 4.03076 2.57789 3.62004 3.19277C3.20932 3.80766 2.99011 4.53057 2.99011 5.27008C2.99011 5.76111 3.08679 6.24732 3.27463 6.70096C3.46247 7.15461 3.7378 7.5668 4.08489 7.914C4.78587 8.61521 5.7366 9.00915 6.72793 9.00915Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4ccc827b424c2ce5fc415a1435f80ed7.svg";
export { ForwardRef as ReactComponent };